import { useNavigate } from 'react-router-dom';
import { UsersPage } from '@practium/features/users';
import type { UsersPermissions } from '@practium/features/users';
import { usePermissions } from '@practium/features/permissions';

export const UsersPageAdmin = () => {
	const navigate = useNavigate();
	const { abilities } = usePermissions();

	const permissions: UsersPermissions = {
		canCreate: abilities.can('create', 'users'),
		canEdit: abilities.can('update', 'users'),
		canDelete: abilities.can('delete', 'users'),
	};

	const handleAddNew = () => {
		navigate('/usuarios/novo');
	};

	const handleViewItem = (id: string) => {
		navigate(`/usuarios/ver?id=${id}`);
	};

	return (
		<UsersPage
			permissions={permissions}
			onAddNew={handleAddNew}
			onViewItem={handleViewItem}
		/>
	);
};
